import {
  Card,
  Col,
  notification,
  Row,
  Tag,
  Button,
  Image,
  Tabs,
  Table,
  Modal,
  Timeline,
} from "antd";
import { API_BASE_URL } from "configs/AppConfig";
import React, { useEffect, useState } from "react";
import fileDownload from "js-file-download";
import AppService from "services/AppService";
import {
  ClockCircleOutlined,
  MinusOutlined,
  CalendarOutlined,
  GlobalOutlined,
  SnippetsFilled,
  DownloadOutlined,
  PhoneFilled,
  HomeTwoTone,
  LinkedinFilled,
  MailFilled,
  EditOutlined,
  BankOutlined
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setLogoActive } from "redux/actions/Auth";
import moment from "moment";
import { Link } from "react-router-dom";
import AvatarStatus from "components/shared-components/AvatarStatus";

const Dashboard = () => {
  const [candidate, setCandidate] = useState(null);
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const dispatch = useDispatch();

  const { TabPane } = Tabs;

  const fetchProfile = async () => {
    try {
      const res = await AppService.fetchProfile();
      setCandidate(res);
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Oops! Unable to fetch details.",
      });
    }
  };

  const getAppliedJobs = async (req, res) => {
    try {
      const res = await AppService.getAppliedJobs(3);
      setAppliedJobs(res);
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Oops! Unable to fetch details.",
      });
    }
  };

  const handleDownload = (data) => {

    if (data.split(".").at(-1) === "pdf") {
      return window.open(
        `${API_BASE_URL}/files/${data}`,
        "_blank"
      );
    }

    AppService.downloadResume(data).then((resp) => {
        fileDownload(resp, data);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchProfile();
    getAppliedJobs();
    dispatch(setLogoActive(true));

    return () => {
      setAppliedJobs(null)
    }

  }, []);

  const columns = [
    {
      title: "Company Name",
      key: "companyName",
      render: (_, elem) => (
        <div>{elem?.company?.companyName}</div>
      )
    },
    {
      title: "Role",
      key: "role",
      render: (_, elem) => (
        <div>{elem?.jobrole?.title}</div>
      )
    },
    {
      title: "Status",
      key: "status",
      render: (_, elem) => (
        <div>{elem?.status ? elem?.status?.title : 'Pending'}</div>
      )
    },
    {
      title: "Applied Date",
      key: "AppliedAt",
      render: (_, elem) => (
        <div>{moment(elem?.createdAt).format("DD-MM-YYYY")}</div>
      )
    },
  ];

  return (
    <div className="main mt-3">
      <section className="company-page dashboard-page">
        <div className="banner"></div>
      </section>
      <section className="dashboard-details">
        <div className="container">
          <Card>
            <Row style={{ position: "relative" }}>
              <Button
                className="edit-options floating d-none d-lg-block"
                href="/app/profile/edit"
                icon={<EditOutlined />}
              >
                Edit
              </Button>

              <Col span={24}>
                <Row gutter={16}>
                  <Col span={24} className="d-sm-none">
                    <Row>
                      <Col
                        span={8}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <Image
                          style={{
                            border: "1px solid #E6EBF1",
                            borderRadius: "10px",
                            aspectRatio: "1",
                            maxWidth: "120px",
                            minWidth: "100px",
                            minHeight: "100px",
                            objectFit: 'cover'
                          }}
                            src={
                              candidate?.profileImg
                                ? `${API_BASE_URL}/image/profile/${candidate?.profileImg}`
                                : `https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=${candidate?.firstName} ${candidate?.lastName}`
                            }
                          // src="https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=john+doe"
                        />
                      </Col>
                      <Col span={16} className="d-flex pl-3 align-items-center">
                        <div className="job-profile-banner align-items-center">
                          <h1
                            className="text-capitalize"
                            style={{ fontSize: "28px" }}
                          >
                            {candidate?.firstName}{" "}{candidate?.lastName}
                          </h1>
                          <div>
                            <Tag color="cyan" className="text-capitalize">
                              Web Developer
                              {/* {applicant?.jobrole?.title} */}
                            </Tag>
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <Button
                                onClick={() => handleDownload(candidate?.resume)}
                              className="mt-3"
                              icon={<DownloadOutlined />}
                            >
                              CV Download
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    className="d-sm-flex d-none justify-content-center align-items-center flex-column"
                    span={24}
                    sm={6}
                    xl={4}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <Image
                        style={{
                          border: "1px solid #E6EBF1",
                          borderRadius: "10px",
                          aspectRatio: "1",
                          maxWidth: "120px",
                          minWidth: "100px",
                          minHeight: "100px",
                          objectFit: 'cover'
                        }}
                          src={
                            candidate?.profileImg
                              ? `${API_BASE_URL}/image/profile/${candidate?.profileImg}`
                              : `https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=${candidate?.firstName} ${candidate?.lastName}`
                          }
                        // src="https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=john+doe"
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <Button
                        onClick={() => handleDownload(candidate?.resume)}
                        className="mt-3"
                        icon={<DownloadOutlined />}
                      >
                        CV Download
                      </Button>
                    </div>
                  </Col>
                  <Col span={24} sm={18} xl={20}>
                    <div className="job-profile-banner align-items-center d-sm-flex d-none">
                      <h1 className="text-center text-sm-left text-capitalize">
                        {candidate?.firstName}{" "}{candidate?.lastName}
                      </h1>
                      <div className="text-center text-sm-left">
                        <Tag color="cyan" className="text-capitalize">
                          {(candidate?.experience && candidate?.experience > 0) ? `Experienced` : 'Fresher' }
                        </Tag>
                      </div>
                    </div>

                    <Row className="dashboard-links-wrap">
                      <Col span={24} lg={10}>
                        <div className="job-profile-description">
                          <Link to="/app">
                            <p className=" mt-3">
                              <MailFilled
                                size={18}
                                style={{ color: "#1890FF" }}
                              />
                              <span className="job-profile-description-data">
                                {candidate?.email}
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    marginBottom: "-8px",
                                  }}
                                ></span>
                              </span>
                            </p>
                          </Link>
                          <p>
                            <PhoneFilled
                              size={18}
                              style={{ color: "#1890FF" }}
                            />
                            <span className="job-profile-description-data text-capitalize">
                              {candidate?.mobileNo ? candidate?.mobileNo : '- -'}
                            </span>
                          </p>
                          <p>
                            <HomeTwoTone
                              size={18}
                              style={{ color: "#1890FF" }}
                            />
                            <span className="job-profile-description-data text-capitalize">
                              {candidate?.address ? candidate?.address : '- -'}
                            </span>
                          </p>
                        </div>
                      </Col>
                      <Col
                        span={24}
                        xl={6}
                        className="d-md-flex justify-content-center flex-column align-items-sm-start align-items-center"
                      >
                        <div className="d-flex justify-content-start align-items-center mb-2">
                          <div>
                            <LinkedinFilled style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Linked In:</span>
                          </div>
                          {
                            candidate?.linkedin ?
                            <a
                              href={candidate?.linkedin}
                              target="_blank"
                              className="font-weight-semibold"
                              style={{ color: "#1890FF" }}
                            >
                              View profile
                            </a> :
                            '- -'

                          }
                        </div>
                        <div className="d-flex justify-content-start align-items-center mb-2 mb-md-0">
                          <div>
                            <CalendarOutlined style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Birth Date:</span>
                          </div>
                          <span className="font-weight-semibold">
                            {candidate?.birthDate ? moment(candidate?.birthDate).format("ll") : '- -'}
                          </span>
                        </div>
                      </Col>
                      <Col
                        span={24}
                        xl={6}
                        className="d-md-flex justify-content-center flex-column align-items-sm-start align-items-center"
                      >
                        <div className="d-flex justify-content-start align-items-center mb-2">
                          <div style={{ minWidth: "95px" }}>
                            <SnippetsFilled style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Experience:</span>
                          </div>
                          <span className="font-weight-semibold">
                            {candidate?.experience ? `${candidate?.experience} Years` : '- -'}
                          </span>
                        </div>
                        {/* {applicant?.candidate?.website ? (
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <GlobalOutlined style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Website:</span>
                          </div>
                          <span className="font-weight-semibold">
                            {applicant?.candidate?.website}
                          </span>
                        </div>
                      ) : (
                        <div
                          className="d-flex justify-content-start align-items-center"
                          style={{ visibility: "hidden" }}
                        >
                          <div>
                            <GlobalOutlined style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Website:</span>
                          </div>
                          <span className="font-weight-semibold"></span>
                        </div>
                      )} */}
                        <div className="d-flex justify-content-start align-items-center">
                          <div className="d-flex align-items-center">
                            <GlobalOutlined style={{ color: "#1890FF" }} />
                            <span className="ml-2 mr-3">Website:</span>
                          </div>
                          <span className="font-weight-semibold">
                            {candidate?.website ? candidate?.website : '- -'}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Tabs className="job-profile-tabs mt-4">
              <TabPane tab="Applied Jobs" key="tab-1">
                <Row gutter={16}>
                  <Col span={24} className="">
                    <div className="heading">
                      <h2>Applied Jobs</h2>
                    </div>
                    <Row gutter={8} className="mt-4">
                      {appliedJobs?.length > 0 ? (
                        <>
                          {appliedJobs?.map((application, i) => (
                              <Col
                                md={8}
                                sm={24}
                                xs={24}
                                style={{ marginBottom: "20px" }}
                                key={i}
                              >
                                <Card
                                  hoverable
                                  onClick={() => {
                                    setSelectedApplication(application)
                                    setShowModal(true);
                                  }}
                                >
                                  <h4 className="mb-0">
                                    {application?.company?.companyName}
                                  </h4>
                                  <p>{application?.jobrole?.title}</p>
                                  <p className="mb-1">
                                    Applied On :{" "}
                                    {moment(application?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </p>
                                  <p>
                                    Updated On :{" "}
                                    {moment(application?.updatedAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </p>
                                  {application?.status ||
                                  application?.result ? (
                                    <>
                                      {application?.status ? (
                                        <Tag color="orange">
                                          {application?.status?.title}
                                        </Tag>
                                      ) : (
                                        <>
                                          {application?.result ===
                                          "Selected" ? (
                                            <Tag color="green">Selected</Tag>
                                          ) : (
                                            <Tag color="red">Rejected</Tag>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <Tag color="blue">Pending</Tag>
                                  )}
                                  <p
                                    style={{
                                      marginBottom: 0,
                                      marginTop: "10px",
                                    }}
                                  >
                                    You will receive the updates on your email
                                  </p>
                                </Card>
                              </Col>
                          ))}
                        </>
                      ) : (
                        "You not applied any job."
                      )}
                    </Row>
                    {appliedJobs?.length > 0 && (
                      <div className="text-center">
                        <Link
                          to="/app/home/applied-jobs"
                          className="custom-btn mt-3 d-inline-block mx-auto"
                        >
                          View All Applied Jobs
                        </Link>
                      </div>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Summary" key="tab-2">
                <Row gutter={16}>
                  <Col span={24} xl={8}>
                    <Card
                      title="Skills"
                      className="candidate-profile-info-card"
                      extra={
                        <Button
                          href="/app/profile/edit-skills"
                          icon={<EditOutlined />}
                        >
                          Edit
                        </Button>
                      }
                    >
                      {
                        candidate?.skills?.split(',').map((skl, i) => (
                          <Tag key={i} color="purple" className="mt-2 text-capitalize">
                            {skl}
                          </Tag>
                        ))
                      }
                    </Card>
                    <Card
                      title="Hobbies"
                      className="candidate-profile-info-card"
                      extra={
                        <Button
                          href="/app/profile/edit-hobbies"
                          icon={<EditOutlined />}
                        >
                          Edit
                        </Button>
                      }
                    >
                      {
                        candidate?.hobbies?.split(',').map((hob, i) => (
                        <Tag key={i} className="mb-2 text-capitalize" color="cyan">
                          {hob}
                        </Tag>
                        ))
                      }
                    </Card>

                    <Card
                      title="Cover Letter"
                      className="candidate-profile-info-card"
                      extra={
                        <Button
                          href="/app/profile/edit-coverletter"
                          icon={<EditOutlined />}
                        >
                          Edit
                        </Button>
                      }
                    >
                      <div dangerouslySetInnerHTML={{__html: candidate?.coverLetter}}></div>
                    </Card>
                  </Col>
                  <Col span={24} xl={16}>
                    <Card
                      title="Experiences"
                      className="candidate-profile-info-card"
                      extra={
                        <Button
                          href="/app/profile/edit-experience"
                          icon={<EditOutlined />}
                        >
                          Edit
                        </Button>
                      }
                    >
                      <div className="mb-3">
                        <Row>
                          {
                            candidate?.experienceDetails?.map((exp, i) => (
                              <Col sm={24} md={22} key={i}>
                                <div className="mb-4">
                                  <AvatarStatus
                                    src={`https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=${exp?.companyName}`}
                                    name={exp?.companyName}
                                    subTitle={`${moment(candidate?.joiningDate).format('ll')} ~ ${moment(candidate?.relievingDate).format('ll')}`}
                                  />
                                  <p className="pl-5 mt-2 mb-0" dangerouslySetInnerHTML={{__html: exp?.expDescp}}></p>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>
                      </div>
                    </Card>
                    <Card
                      title="Educations"
                      className="candidate-profile-info-card"
                      extra={
                        <Button
                          href="/app/profile/edit-education"
                          icon={<EditOutlined />}
                        >
                          Edit
                        </Button>
                      }
                    >
                      <div className="mb-3">
                        <Row>
                          {
                            candidate?.education.map((edu, i) => (
                              <Col sm={24} md={22} key={i}>
                                <div className="mb-4">
                                  <AvatarStatus
                                    // src={`https://ui-avatars.com/api/?background=f1f1f1&color=aaa&name=yale+university`}
                                    icon={<BankOutlined />}
                                    name={`${edu?.university?.charAt(0)?.toUpperCase()}${edu?.university.slice(1)}`}
                                    subTitle={moment(edu?.passoutDate).format('ll')}
                                  />
                                  <p className="pl-5 mt-2 mb-0 text-capitalize">
                                   {edu?.degree} - {edu?.branch}
                                    {
                                      edu?.percentage &&
                                      <p>
                                        Percentage: {edu?.percentage}
                                      </p>
                                    }
                                  </p>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="History" key="tab-3">
                <Card>
                  <Table
                    pagination={false}
                    columns={columns}
                    dataSource={appliedJobs}
                    rowKey={(elm) => elm._id}
                  />
                </Card>
              </TabPane>
            </Tabs>
          </Card>
        </div>
      </section>

      <Modal
        title={selectedApplication?.jobrole?.title}
        centered
        visible={showModal}
        onCancel={() => {setShowModal(false); setSelectedApplication(null)}}
        footer={null}
      >
        <Card style={{maxHeight: '500px', overflowY: 'auto'}}>
            <Timeline>
              {
                  selectedApplication?.applicationTimeLine?.map((item, i) => (
                      <Timeline.Item key={i}>
                          <Card 
                              title={
                                  <>
                                      <h6 className='mb-0' style={{color: '#3E79F7'}}>{selectedApplication?.company?.companyName}</h6>
                                      <span style={{color: '#c80e77'}}>{item.title}</span>
                                  </>
                              }
                              extra={<span>{moment(item?.time).format('D MMM YY')}</span>}
                              size='small'
                              bodyStyle={{ paddingTop: 0 }}
                          >
                              <h4 className='mb-0'>
                                  {selectedApplication?.jobrole?.title} - <small>{selectedApplication?.jobrole?.empType}</small>
                              </h4>

                              {
                                  item?.title === 'Interview scheduled' &&
                                  <ul className='pl-3 mt-2'>
                                      <li>
                                          Interview Timing: <b>{moment(selectedApplication?.interviewDate).format('ll')}, <span>{moment(selectedApplication?.interviewTime).format('LT')}</span></b>
                                      </li>
                                      <li>
                                          {selectedApplication?.company?.companyAddress?.address}
                                      </li>
                                      <li>
                                          {selectedApplication?.company?.companyAddress?.city}, {selectedApplication?.company?.companyAddress?.state}, {selectedApplication?.company?.companyAddress?.country}
                                      </li>
                                      {
                                          selectedApplication?.company?.companyAddress?.mapLink &&
                                          <li>
                                              Map Link: 
                                              <a className='ml-2' style={{color: '#3E79F7'}} href={selectedApplication?.company?.companyAddress?.mapLink} target='_blank'>
                                                  {selectedApplication?.company?.companyAddress?.mapLink}
                                              </a>
                                          </li>
                                      }
                                  </ul>
                              }
                          </Card>
                      </Timeline.Item>
                  ))
              }
          </Timeline>
        </Card>
      </Modal>

    </div>
  );
};

export default Dashboard;
